var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadOrderIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.371 18.4C4.431 18.4 4.491 18.3943 4.551 18.3856L9.597 17.5375C9.657 17.526 9.714 17.5001 9.756 17.457L22.473 5.26987C22.5008 5.24328 22.5229 5.21168 22.5379 5.1769C22.553 5.14213 22.5607 5.10484 22.5607 5.06719C22.5607 5.02953 22.553 4.99225 22.5379 4.95747C22.5229 4.92269 22.5008 4.8911 22.473 4.8645L17.487 0.083375C17.43 0.02875 17.355 0 17.274 0C17.193 0 17.118 0.02875 17.061 0.083375L4.344 12.2705C4.299 12.3136 4.272 12.3654 4.26 12.4229L3.375 17.2586C3.34582 17.4126 3.35624 17.5712 3.40538 17.7204C3.45452 17.8697 3.54088 18.0053 3.657 18.1154C3.855 18.2994 4.104 18.4 4.371 18.4ZM6.393 13.386L17.274 2.96125L19.473 5.06862L8.592 15.4934L5.925 15.9447L6.393 13.386ZM23.04 20.815H0.96C0.429 20.815 0 21.2261 0 21.735V22.77C0 22.8965 0.108 23 0.24 23H23.76C23.892 23 24 22.8965 24 22.77V21.735C24 21.2261 23.571 20.815 23.04 20.815Z",
    fill: "black",
    fillOpacity: 0.85
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadOrderIcon);
export default __webpack_public_path__ + "static/media/upload-order-icon.50ca876ac30e2f883a9c2c59f60449c1.svg";
export { ForwardRef as ReactComponent };